<script setup>
import { ref, inject } from "vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";

const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
// const dashboardURL = ref(`${window.location.origin}/tenant`);

const display = ref(true);
const route = useRoute();
const router = useRouter();
const primarycolor = inject("primarycolor");
const source = route.query.source || sessionStorage.getItem("previousRoute");
console.log(source, "source");

const done = () => {
  display.value = false;
  if (source) {
    router.push(source);
    sessionStorage.removeItem("previousRoute"); // clean up
  } else {
    router.push("/tenant");
  }
};

const closePaymentModal = () => {
  display.value = false;
  if (source) {
    router.push(source);
    sessionStorage.removeItem("previousRoute");
  } else {
    router.push("/tenant");
  }
};
</script>
<template>
  <div class="container-top" :class="{ 'container-wide': lgAndUp || xlAndUp }">
    <el-dialog
      title=""
      class="border-radius-20"
      v-model="display"
      :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
      align-center
      :modal="true"
      :show-close="false"
    >
      <div class="row justify-content-center">
        <div class="col-md-12 d-flex justify-content-end">
          <div>
            <el-button class="border-0" @click="closePaymentModal"
              ><el-icon :size="20"><Close /></el-icon
            ></el-button>
          </div>
        </div>
        <div
          class="col-md-10 mt-3 bg-white mb-3"
          v-if="route.fullPath.includes('payments/success')"
        >
          <div class="row justify-content-center align-items-center">
            <div class="col-md-10 col-12 d-flex justify-content-center">
              <div class="col-6">
                <img
                  class="w-100"
                  src="../../assets/mobileonboarding/sub-successful.gif"
                  alt=""
                />
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center">
              <div class="col-md-10 col-12 px-0">
                <div
                  class="text-head font-weight-bold col-md-12 px-0 h2 text-center"
                  style="color: #78b348"
                >
                  Your Payment is Successful!
                </div>
              </div>
            </div>
            <div class="col-md-10 d-flex my-5 justify-content-center">
              <div class="col-md-8">
                <el-button
                  @click="done"
                  :color="primarycolor"
                  size="large"
                  class="w-100"
                  round
                  >Done
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="false">
        <div class="col-md-12 d-flex justify-content-between">
          <div class="s-18 font-weight-600 text-dak">Payment Status</div>
          <div>
            <el-button class="border-0" @click="closePaymentModal"
              ><el-icon :size="20"><Close /></el-icon
            ></el-button>
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="route.fullPath.includes('payments/success')"
        >
          <div class="col-md-12 d-flex justify-content-center">
            <div class="col-md-8">
              <img
                class="w-100"
                src="../../assets/mobileonboarding/sub-successful.gif"
                alt=""
              />
            </div>
          </div>
          <div class="col-md-12 d-flex justify-content-center">
            <div class="col-md-10 col-12 px-0">
              <div
                class="text-head font-weight-bold col-md-12 px-0 h2 text-center"
                style="color: #78b348"
              >
                Your Payment is Successful!
              </div>
            </div>
          </div>
          <div class="col-md-12 d-flex my-5 justify-content-center">
            <div class="col-md-8">
              <el-button
                @click="done"
                :color="primarycolor"
                size="large"
                class="w-100"
                round
                >Done
              </el-button>
            </div>
          </div>
          <!-- <div class="col-12 col-md-12 ">
            <h2 class="text-center mt-4  font-weight-bold text-dak">Congrats</h2>
            <div class="text-center mt-2 text-dak font-weight-600 s-18">
              Your payment is Successful <br />Click the button below to go to
              the dashboard
            </div>
            <div class="d-flex justify-content-center mb-5">
              <a :href="dashboardURL" class="no-decoration">
                <el-button color="#70c043" class="text-white mt-3" round
                  >Go to dashboard</el-button
                >
              </a>
            </div>
          </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>
